import React from 'react';

const CourseDetail = props => {
    return (
      <div className="PlanCardCourse" >
        <div className="PlanCardCourseTitle" >
          {props.name}
        </div>
        <div className="PlanCardCourseDetailContainer" >
          <div className="PlanCardCourseDetail" >
            通常料金 /月
          </div>
          <div className="PlanCardCoursePrice" >
            {`${props.price}円`}
          </div>
          <div className="PlanCardCourseWithTax" >
            （税込 {`${props.priceWithTax}円`}）
          </div>
        </div>
      </div>
    );
  };

export default CourseDetail;
